<template>
<div class="chapter">
<div class="inner_page">
<div class="lines"><img alt="" class="img23" src="Images/line_top.jpg"/></div>
<p class="tp4" title="PART II: Law">PART II</p>
<div class="lines"><img alt="" class="img23" src="Images/line_bottom.jpg"/></div>
<h2 class="sigil_not_in_toc" id="toc_marker-3-2" xml:lang="fr-FR">LAW</h2>
<p class="veryfirst">Why is law to some a hobgoblin of incarnate evil to be exorcised from life, while to others it is the only hope of salvation? What is law’s purpose, and how can it be known?</p>
<p class="body">A law is any rule or injunction that must be obeyed. In traditional religion, these rules normally make requirements of a ceremonial or ritual kind and of an ethical or moral kind. In fact, these laws are so prominent in most religions as to be considered the substance of those religions. This was true of the Jewish religious leaders in Christ’s day, and it is true in much of Christendom today. Is this the biblical point of view? Certainly there are many laws in the Bible—613 Mosaic commandments and more than 600 direct commandments in the New Testament. Are they rules that must be obeyed? <em class="i">Can</em> they be obeyed? If not, for what purpose were they given? Before these and other vital questions can be answered, it is important to permit the Bible itself to define the term.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?29394c1a